import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Loader } from 'web-ui-components/lib/organisms/modals';
import { BackButton } from 'web-ui-components/lib/molecules/navigation';
import withContent from '../../containers/withContent';
import PageNavigation from '../../sharedComponents/PageNavigation/PageNavigation';
import PaymentReason from './Reason';
import {
	updateReason,
	setUIError,
	createEWOutcome,
	resetEffectiveWarning,
	CREATE_OUTCOME_SUCCESS,
} from '../state/actions';
import { PaymentReasonProps, ContentProps } from '../state/propTypes';
import {
	getReasons,
	isUiError,
	// getApiError,
	getSelectedReasonId,
	isSMEUser,
	getNextPage,
	getEffectiveWarningId,
} from '../state/selectors';
import { hasApiCallInProgress } from '../../states/api/selectors';
import ewContent from '../utils/content';
import { goToPage, pages } from '../../states/page/actions';
import { hasReadTimeOutError } from '../../states/page/selectors';
import { IBActions } from '../utils/constants';

const mapState = (state, props) => ({
	paymentReasons: getReasons(state),
	// apiError: getApiError(state),
	isUiError: isUiError(state),
	reasonId: getSelectedReasonId(state),
	isSMEUser: isSMEUser(state),
	effectiveWarningNextStep: getNextPage(state),
	apiInProgress: hasApiCallInProgress(state),
	effectiveWarningId: getEffectiveWarningId(state, props.payType),
	readTimeOutError: hasReadTimeOutError(state),
});

const mapDispatch = (dispatch) => ({
	setUIError: (val) => dispatch(setUIError(val)),
	updateReason: (id, reason) => dispatch(updateReason(id, reason)),
	goToPage: (page) => dispatch(goToPage(page)),
	createEWOutcome: (payType) => dispatch(createEWOutcome(payType)),
	resetEffectiveWarning: () => dispatch(resetEffectiveWarning()),
});

export class Transaction extends Component {
	constructor(props) {
		super(props);
		this.handleContinue = this.handleContinue.bind(this);
		this.handleCancel = this.handleCancel.bind(this);
		this.handleBack = this.handleBack.bind(this);
		this.state = { showLoading: false };
	}

	componentDidMount() {
		const { isSMEUser, onAction } = this.props;

		if (!isSMEUser) onAction(IBActions.ON_REVIEW, { val: false, page: 'ewPaymentReason' });
	}

	handleContinue(event) {
		event.preventDefault();
		this.setState({ showLoading: true });
		const { reasonId, setUIError, createEWOutcome, payType, onContinue } = this.props;
		// REFACTOR: this api call should be moved out to the calling container
		if (reasonId) {
			createEWOutcome(payType).then((response) => {
				if (response.type === CREATE_OUTCOME_SUCCESS) onContinue();
				else this.setState({ showLoading: false });
			});
		} else {
			this.setState({ showLoading: false });
			setUIError(true);
		}
	}

	handleCancel(event) {
		event.preventDefault();
		this.props.goToPage(pages.EffectiveWarning.paymentCancelled);
	}

	handleBack(event) {
		event.preventDefault();
		const { resetEffectiveWarning, handleBack } = this.props;
		resetEffectiveWarning();
		handleBack();
	}

	render() {
		const {
			paymentReasons,
			reasonId,
			updateReason,
			isUiError,
			setUIError,
			content,
			onAction,
			isSMEUser,
			apiInProgress,
			effectiveWarningId,
			readTimeOutError,
		} = this.props;
		const { cancelPaymentText, reviewPaymentText, continueText } = content;

		if ((apiInProgress || this.state.showLoading) && !readTimeOutError) return <Loader isOpen />;

		return (
			<div id="reasonPage" data-ewId={effectiveWarningId}>
				{isSMEUser && <BackButton onClick={this.handleBack} />}
				<PaymentReason
					reasons={paymentReasons}
					reasonId={reasonId}
					updateReason={updateReason}
					isUiError={isUiError}
					setUIError={setUIError}
					content={content}
					onAction={onAction}
					isSMEUser={isSMEUser}
				/>
				<PageNavigation
					handleContinue={this.handleContinue}
					handleBack={this.handleCancel}
					showContinue
					enableContinue
					enableBack
					showBack
					secondaryButtonText={cancelPaymentText}
					continueButtonText={isSMEUser ? continueText : reviewPaymentText}
				/>
			</div>
		);
	}
}

Transaction.propTypes = {
	paymentReasons: PropTypes.arrayOf(PropTypes.shape(PaymentReasonProps)),
	content: PropTypes.shape(ContentProps),
	goToPage: PropTypes.func,
	createEWOutcome: PropTypes.func,
	updateReason: PropTypes.func,
	setUIError: PropTypes.func,
	onContinue: PropTypes.func,
	onAction: PropTypes.func,
	isUiError: PropTypes.bool,
	isSMEUser: PropTypes.bool,
	payType: PropTypes.string,
	reasonId: PropTypes.string,
	apiInProgress: PropTypes.bool,
	effectiveWarningId: PropTypes.string,
	resetEffectiveWarning: PropTypes.func,
	handleBack: PropTypes.func,
	readTimeOutError: PropTypes.bool,
};

export default compose(connect(mapState, mapDispatch), withContent({ content: ewContent }))(Transaction);
